export default __webpack_public_path__ + "static/media/img--design-9.a482a68a.jpg";